import { Branch } from "../types/branch";

export class GoogleMapsApi {
  static GetDistances(position: Position, branches: Branch[]): Promise<google.maps.DistanceMatrixResponse> {
    const destinations: google.maps.LatLng[] = branches.map(b => {
      return new google.maps.LatLng(b.latitude, b.longitude);
    });

    const service = new google.maps.DistanceMatrixService();
    const promise = new Promise<google.maps.DistanceMatrixResponse>((resolve, reject) => {
      service.getDistanceMatrix(
        {
          origins: [new google.maps.LatLng(position.coords.latitude, position.coords.longitude)],
          destinations,
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.IMPERIAL
        },
        (response, status) => {
          if (status === google.maps.DistanceMatrixStatus.OK) {
            resolve(response);
          } else {
            reject("Could not retrieve branch distance");
          }
        }
      );
    });
    return promise;
  }
}
